"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInSupportedTrialPeriod = exports.calculateTrialDaysToAdd = void 0;
const types_1 = require("@fluent-forever/types");
const moment_1 = __importDefault(require("moment"));
const calculateTrialDaysToAdd = ({ isInTrial, maxStreak, trialDaysAdded, }) => {
    if (isInTrial) {
        if (maxStreak === 5 && trialDaysAdded === 0) {
            return 3;
        }
        if (maxStreak === 12 && trialDaysAdded + 7 <= 10) {
            return 7;
        }
    }
    return 0;
};
exports.calculateTrialDaysToAdd = calculateTrialDaysToAdd;
/**
 * Returns a boolean indicating if the user has a non-expired
 * supported trial.
 *
 * By supported trial we mean a trial which we have full control
 * over, which in this case is only for subscriptions purchased
 * through Chargebee. For this kind of trials, we can extend
 * the trial (e.g.: automatically when the user reaches certain
 * high streaks) or adjust it at will.
 *
 * Trials given to the user in the from of free days when purchasing
 * an In-App purchase are not considered supported trials.
 */
const isInSupportedTrialPeriod = (permissions) => permissions.subscriptionProvider === types_1.SubscriptionProviderEnum.Chargebee &&
    permissions.trialExpirationDate
    ? moment_1.default().isBefore(permissions.trialExpirationDate)
    : false;
exports.isInSupportedTrialPeriod = isInSupportedTrialPeriod;
//# sourceMappingURL=trial_period.js.map